import WithLazyBackgroundImage from './withLazyBackgroundImage';

export default WithLazyBackgroundImage;
